/*  ========================================================================
    # Scripts - Image Slider
    ========================================================================  */

/**
 * Script that handles the image slider.
 */
const ImageSlider = {
  cfg: {
    images: document.querySelectorAll('.s-image-slider__entry')
  },

  /**
   * Handle images.
   */
  handleImages() {
    const maxHeight = window.innerWidth > 1024 ? 420 : 280; // Set a maximum height for the caption
    const maxWidth = window.innerWidth > 1024 ? 480 : 320; // Set a maximum width for the caption

    this.cfg.images.forEach((fig, index) => {
      const imageWidth = fig.getAttribute('data-width');
      const imageHeight = fig.getAttribute('data-height');
      const aspectRatio = imageWidth / imageHeight;

      // calc height based on max width and aspect ratio
      let captionHeight = maxWidth / aspectRatio;

      // if calculated height exceeds max height, cap it and adjust width accordingly
      if (captionHeight > maxHeight) {
        captionHeight = maxHeight;
        const captionWidth = captionHeight * aspectRatio;
        fig.style.setProperty('--img-rendered-width', captionWidth + 'px');
      } else {
        fig.style.setProperty('--img-rendered-width', maxWidth + 'px');
      }
      // Function to trigger animation
      setTimeout(() => {
        fig.classList.add('loaded'); // or 'animate'
      }, index * 50); // Stagger by 50ms
    });
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.images.length > 0) {
      this.handleImages();
    }

    window.addEventListener('resize', () => {
      this.handleImages();
    });
  }
};

export default ImageSlider;
